import { render, staticRenderFns } from "./Shortcut.vue?vue&type=template&id=2b7838bd&scoped=true&"
import script from "./Shortcut.vue?vue&type=script&lang=js&"
export * from "./Shortcut.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Eit.css?vue&type=style&index=0&id=2b7838bd&scoped=true&lang=css&"
import style1 from "./Shortcut.vue?vue&type=style&index=1&id=2b7838bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7838bd",
  null
  
)

export default component.exports